import FreeNumberTypes from "../constants/FreeNumberTypes";
import Steps from "../constants/Steps";
import { TransitionSteps } from "../constants/TransitionSteps";
import { IFixedNumber } from "../entities/manhattan/freeNumber/types";
import { ICheckoutData } from "../entities/manhattan/order/types";
import { splice } from "../utilites/strings";
import { putCharAfterPostalNumber } from "./prepareFixedNumbers";

export const formatMobilePhone = (freePhoneNumber: string): string => {
  const numberwithSlash =  putCharAfterPostalNumber(freePhoneNumber, '/');
  return splice(numberwithSlash, 7, '-');
};

export const profileOperator = (
  order: { checkoutData: ICheckoutData},
  labels: any
): { checkoutData: ICheckoutData} => {
  order.checkoutData
    .steps
    .current
    .data
    .freeFixedNumbers
    .forEach((item: IFixedNumber) => {
      item['label'] = labels[item.type];
      item.freeNumbers
        .forEach((freeNumber: any, index: number) => {
          item.freeNumbers[index] = putCharAfterPostalNumber(freeNumber, "/");
        });
    });

  return order;
};

export const getTransferredPhoneNumber = (checkoutData: ICheckoutData): boolean => {
  const isTransferredPhoneNumber = checkoutData.steps.current.data.isTransferredPhoneNumber;

  return (
    isTransferredPhoneNumber === null ||
      typeof isTransferredPhoneNumber !== 'undefined' ?
      isTransferredPhoneNumber : false
  );
};

type TelcoOperator = {
  value: string | number,
  label: string
};

export const prepareTelcoOperatorsOptions = (
  checkoutData: ICheckoutData
): TelcoOperator[] => {
  return checkoutData.steps.current.data.telcoOperators.map((item: any) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
};

export const getUsesOptics = (checkoutData: ICheckoutData): null | boolean => {
  const usesOptics = checkoutData.steps.current.data.usesOptics;

  return typeof usesOptics === 'undefined'  ? null : usesOptics;
};

export const getSelectedPhoneNumberByStep = (checkoutData: ICheckoutData, step: string) => {
  if (step === Steps.PREVIOUS) {
    const operatorProfileState = checkoutData.steps.previous.find((item: any) => item.step === TransitionSteps.FTTH.OPERATOR_PROFILE_STATE);
    return typeof operatorProfileState !== 'undefined' ? putCharAfterPostalNumber(operatorProfileState.data.phoneNumber, "/") : "";
  }

  if (step === Steps.CURRENT) {
    return typeof checkoutData.steps.current.data.phoneNumber !== 'undefined' &&
    checkoutData.steps.current.data.phoneNumber ? putCharAfterPostalNumber(checkoutData.steps.current.data.phoneNumber, "/") :
      checkoutData.steps.current.data.freeFixedNumbers.find((item: any) => item.type === FreeNumberTypes.STANDARD).freeNumbers[0];
  }

  return null;
};
